import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useRouter } from 'next/router';

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from '@chakra-ui/react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import theme from 'styles/themes/default';

import DrawerElement from 'components/atom/Drawer';
import Button from 'components/atom/Form/Button';
import Checkbox from 'components/atom/Form/Checkbox';

import { useSearchController } from '../../hooks/useSearchController';
import { Container, FooterFilter } from './styles';

const possibleLanguages = ['en', 'es', 'pt-BR'] as const;
type Language = (typeof possibleLanguages)[number];

const Filter: React.FC = () => {
  const { t } = useTranslation();
  const {
    isOpenModalFilters,
    setIsOpenModalFilters,
    isLoading,
    surveyQuestions,
    formik: { setFieldValue, handleSubmit, values },
  } = useSearchController();

  const router = useRouter();

  const currentLanguage = (router.locale as Language) || 'pt-BR';

  return (
    <DrawerElement
      isOpen={isOpenModalFilters}
      placement="right"
      onClose={() => setIsOpenModalFilters(false)}
      size="lg"
      title={t('meetings:search.title')}
    >
      <Container>
        <Accordion allowMultiple>
          {(surveyQuestions || []).slice(0, 2).map((question: any) => {
            const data = question[currentLanguage] || question['pt-BR'];

            return (
              <AccordionItem key={data.id}>
                <AccordionButton>
                  {data.name}
                  <AccordionIcon />
                </AccordionButton>

                <AccordionPanel pb={4}>
                  {Object.keys(data.options).map((option: string) => {
                    const optionData = data.options?.[option];

                    return (
                      <>
                        {optionData.length > 1 && (
                          <Box padding="1rem 1.5rem" bg={theme.colors.medium.color} color="#FFF">
                            {optionData[0].groupName}
                          </Box>
                        )}

                        {optionData.map((item: any, i: number) => {
                          const translatedIds = `${question?.en.options[option][i].id}-${question?.es.options[option][i].id}-${question?.['pt-BR'].options[option][i].id}`;

                          return (
                            <Checkbox
                              key={i}
                              isChecked={values[translatedIds]}
                              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                setFieldValue(translatedIds, e.target.checked);
                              }}
                            >
                              {item.label}
                            </Checkbox>
                          );
                        })}
                      </>
                    );
                  })}
                </AccordionPanel>
              </AccordionItem>
            );
          })}
        </Accordion>

        <FooterFilter>
          <Button
            theme="blue03"
            text={t('meetings:actions.applyFilters')}
            icon={faCheck}
            onClick={() => handleSubmit()}
            isLoading={isLoading}
          />
        </FooterFilter>
      </Container>
    </DrawerElement>
  );
};

export default Filter;
